var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 583.86 216.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#23c99d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "56.2 196.71 56.2 216.18 120.73 216.18 120.73 196.71 88.47 176.59 56.2 196.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "151.22 32.03 151.22 0 25.72 0 25.72 32.03 88.47 55.24 151.22 32.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.94,100.93,154,42.32,88.47,68.05,23,42.32,0,100.93l49,18.19L33.44,166l22.27,19.86,32.76-20.74,32.76,20.74L143.5,166,128,119.12ZM132.32,163l-12.08,10.78L93.3,156.72V141.67L108.7,135V100.39l19.08-7.07-3.36-9.06L99,93.66v35l-10.56,4.57-10.56-4.57v-35l-25.39-9.4-3.36,9.06,19.08,7.07V135l15.39,6.65v15.05L56.7,173.78,44.62,163,61.1,113.3l-48.5-18L28.45,54.86l60,23.58,60-23.58,15.86,40.43-48.51,18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212.26,114.62V43.92h19.27V98.1h24v16.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M270.84,114.62V43.92h43.32V59.47H289.62V71.69h23.14V86.9H289.62V98.78h24.54v15.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M405.43,79.41a37.35,37.35,0,0,1-2.75,14.35,36.68,36.68,0,0,1-8.21,11.88,38.15,38.15,0,0,1-12.35,8,39.42,39.42,0,0,1-14.43,2.85,38.87,38.87,0,0,1-14.43-2.85,36.21,36.21,0,0,1-12.26-8,35.8,35.8,0,0,1-8.21-12,36.55,36.55,0,0,1,0-28.49,35.8,35.8,0,0,1,8.21-12,36.25,36.25,0,0,1,12.26-8.11,37.75,37.75,0,0,1,14.43-2.76,38.33,38.33,0,0,1,14.52,2.78,36.45,36.45,0,0,1,23.22,34.31Zm-37.77,20.77A17.22,17.22,0,0,0,381,94.24a18.81,18.81,0,0,0,3.91-6.62,25.13,25.13,0,0,0,1.26-8.21,21.68,21.68,0,0,0-5.26-14.82,17.14,17.14,0,0,0-13.24-5.94,16.9,16.9,0,0,0-13.28,5.94,21.63,21.63,0,0,0-5.21,14.82q0,9.23,5.12,14.93A17.2,17.2,0,0,0,367.66,100.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M460.33,114.62V43.92h43.32V59.47H479.12V71.69h23.13V86.9H479.12v27.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M545.11,60.34a.26.26,0,0,1,.09.19,27.55,27.55,0,0,1,2.27,5.6,19.78,19.78,0,0,1,2.17-5.21,1.68,1.68,0,0,1,.29-.58l8.5-16.42h22.92l-23.6,34,26.11,36.7H562l-12.07-21c-.26-.48-.55-1-.87-1.69s-.53-1-.62-1.21c-.23-.54-.55-1.53-1-2.94a22.07,22.07,0,0,1-1,3.18c-.16.39-.62,1.28-1.35,2.66l-12.07,21H511.18l26.2-37.09L513.69,43.92h22.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M225,149.14v36.71h-9.63V149.14h-11V141H236v8.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M319.91,185.85H308.85l-11.8-21v21h-9.6V141h13.73q8.19,0,12.26,3.18t4.08,9.54a11.8,11.8,0,0,1-2.79,7.91,10.88,10.88,0,0,1-7.2,3.83Zm-22.86-25.74h1.44c3.88,0,6.44-.43,7.69-1.27s1.87-2.33,1.87-4.43-.67-3.78-2-4.71-3.85-1.39-7.55-1.39h-1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M365.35,185.85,382.42,141h11l17.32,44.87H399.8l-3.65-9.53H378.77l-3.12,9.53Zm28.56-17.07-5-14.49a20.92,20.92,0,0,1-.55-2.21c-.23-1-.46-2.32-.71-3.83-.26,1.45-.52,2.75-.77,3.9s-.42,1.93-.55,2.32l-4.84,14.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M460.62,185.85V141h12.23a50.82,50.82,0,0,1,11.4,1,20,20,0,0,1,7.33,3.38,19.38,19.38,0,0,1,6.17,7.64,27.29,27.29,0,0,1,0,21.09,19.39,19.39,0,0,1-6.29,7.62,20.2,20.2,0,0,1-6.82,3.17,47.26,47.26,0,0,1-11,1h-13Zm9.59-8.09h5.34q7.54,0,11-3.43T490,163.45q0-7.42-3.44-10.87t-11-3.44h-5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M553.08,185.85V141h26.41v8.1H562.67v9.22h16.82v8.15H562.67V177.7h16.82v8.15Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyLogo);
export default __webpack_public_path__ + "static/media/company-logo.f9d96b268d4de72cb70b6a4196a7da31.svg";
export { ForwardRef as ReactComponent };